/**
 * HSS Selection — client-side companion to the [hss_selection] shortcode.
 *
 * class-hss-selection.php server-renders the initial text (no flash of
 * empty content on first paint) and stashes its shortcode attributes as
 * data-* on the wrapper element. This script re-resolves state the same
 * way the chip bar does — HSSCore.resolveInitialState(), URL wins when
 * present, else the FWPVFM + feature cookies — and repaints on every
 * 'facetwp-loaded' event, so a copy of this shortcode sitting in a global
 * header stays in sync when a visitor changes the filter elsewhere on the
 * page without a full reload (exactly the same no-reload path the chip bar
 * and configurator already use).
 *
 * build() intentionally mirrors HSS_Selection::build_text() in PHP line for
 * line — same auto-mode join + " • " feature suffix, same {placeholder}
 * substitution in custom-format mode — so the server-rendered first paint
 * and every client-side repaint after it produce identical text.
 */
(function () {
	'use strict';

	function buildText(state, data) {
		var year    = (state.year    && state.year.name)    || '';
		var model   = (state.model   && state.model.name)   || '';
		var trim    = (state.trim    && state.trim.name)    || '';
		var feature = (state.feature && state.feature.name) || '';

		var text;
		if (data.format) {
			text = data.format
				.replace(/\{year\}/g,    year)
				.replace(/\{model\}/g,   model)
				.replace(/\{trim\}/g,    trim)
				.replace(/\{feature\}/g, feature);
			text = text.replace(/\s+/g, ' ').trim();
		} else {
			var main = [year, model, trim].filter(function (s) { return s; }).join(data.separator || ' ');
			text = main;
			if (data.showFeature !== 'false' && data.showFeature !== '0' && feature) {
				text = text ? text + ' • ' + feature : feature;
			}
		}

		return text || data.emptyText || '';
	}

	function repaintAll(els, config) {
		var state = window.HSSCore.resolveInitialState(config);
		els.forEach(function (el) {
			el.textContent = buildText(state, el.dataset);
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		if (typeof window.HSSCore === 'undefined') return;

		var els = document.querySelectorAll('.hss-selection-text');
		if (!els.length) return;

		// Ensure `flat` is populated even on a page where the chip bar
		// itself isn't present (HSSBar.init() bails out early without
		// calling buildFlat() when #hss-search-wrap is missing) — cheap
		// and safe to call again if it already was.
		window.HSSCore.buildFlat(window.hssTree, window.hssFeatureCategories);

		// hssConfig is localized sitewide by enqueue_frontend(); fall back
		// to the documented defaults on the off chance it's missing.
		var config = window.hssConfig || {
			paramModel:   '_model_filter',
			paramKeyword: '_keyword_search',
			paramFeature: '_feature_category'
		};

		var elList = Array.prototype.slice.call(els);
		repaintAll(elList, config);

		if (window.jQuery) {
			window.jQuery(document).on('facetwp-loaded', function () {
				repaintAll(elList, config);
			});
		}
	});
}());
